import styled from 'styled-components/macro'

const TableStyle = styled.table`
  //box-shadow: 0 0.5rem 0.3rem -0.3rem #ccc;
  border-collapse: collapse;
  font-size: 0.7rem;
  background-color: #fff;
  width: 100%;
`

const Tr = styled.tr`
  &:hover {
    background-color: #f2f2f2;
  }
`

const Th = styled.th`
  padding: 0 0.5rem;
  border-bottom: 1px solid #d7d7d8;
  height: 2.4rem;
  background-color: #1470d5;
  font-size: 0.8rem;
  font-family: 'Montserrat';
  color: #fff;
  font-weight: 600;
  text-align: left;
  white-space: nowrap;

  &:first-child {
    padding: 0 0.5rem 0 1rem;
  }
  &:last-child {
    padding: 0 1rem 0 0.5rem;
  }
`

const Td = styled.td`
  padding: 0 0.5rem;
  border-bottom: 1px solid #d7d7d8;
  font-family: roboto;
  height: 2.4rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  &:first-child {
    padding: 0 0.5rem 0 1rem;
  }

  &:last-child {
    padding: 0 1rem 0 0.5rem;
  }
`

const NotFoundWrapper = styled.section`
  width: 100%;
`
const NotFoundContent = styled.div`
  font-family: roboto;
  text-align: center;
  padding: 5rem 0;
`

const NotFoundImg = styled.img`
  padding-bottom: 2.4rem;
`

const NotFoundTitle = styled.h3`
  margin-bottom: 0.8rem;
  font-size: 1rem;
`

const NotFoundText = styled.p`
  font-size: 0.6rem;
  line-height: 0.9rem;
  margin-bottom: 1rem;
`

const NotFoundButton = styled.button`
  padding: 0.5rem 1rem;
  background-color: #0485dc;
  color: #fff;
  font-weight: 400;
  border: none;
  border-radius: 0.2rem;

  &:hover {
    padding: 0.5rem 1rem;
    background-color: #072558;
  }
`

export {
  TableStyle,
  Tr,
  Th,
  Td,
  NotFoundWrapper,
  NotFoundContent,
  NotFoundImg,
  NotFoundTitle,
  NotFoundText,
  NotFoundButton,
}
